import { Button, Stack, Typography } from '@mui/material'
import LogoutIcon from '@mui/icons-material/Logout'
import { fixarTenantDispositivo } from '../lib/tenant'
import { ehAparelhoKiosk } from '../lib/kiosk'
import { urlLoginPdv } from '../lib/url-pdv'

export function BotaoVoltarPdv(): JSX.Element | null {
  const url = urlLoginPdv()

  if (!ehAparelhoKiosk() || !url) return null

  const voltarAoPdv = (): void => {
    fixarTenantDispositivo(null)
    window.location.href = url
  }

  return (
    <Stack spacing={1.5} alignItems="center" sx={{ mt: 2 }}>
      <Button
        variant="outlined"
        fullWidth
        size='large'
        startIcon={<LogoutIcon />}
        onClick={voltarAoPdv}
        sx={{ textTransform: 'none' }}
      >
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Voltar para o login do PDV
        </Typography>
      </Button>

      <Typography variant="body2" color="text.secondary">
        Faça login no PDV para escolher novamente o totem deste aparelho.
      </Typography>
    </Stack>
  )
}
